import styled from '@emotion/styled'
import { easing } from '../../__styling/settings/easing'

export type NativeLazyLoading = 'lazy' | 'eager'

export interface StyledImageProps {
    show?: boolean
    loading?: NativeLazyLoading
}

export const StyledImage = styled('img')<StyledImageProps>(
    {
        display: 'block',
        transition: `opacity ${easing.easeOut.med}`,
    },
    (props) => ({
        opacity: props.show === false ? 0 : 1,
    }),
)
